/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "imu";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ImuMuxSourcePb {
}

export enum ImuMuxSourcePb_Enum {
  INVALID = 0,
  PRIMARY = 1,
  SECONDARY = 2,
  UNRECOGNIZED = -1,
}

export function imuMuxSourcePb_EnumFromJSON(object: any): ImuMuxSourcePb_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return ImuMuxSourcePb_Enum.INVALID;
    case 1:
    case "PRIMARY":
      return ImuMuxSourcePb_Enum.PRIMARY;
    case 2:
    case "SECONDARY":
      return ImuMuxSourcePb_Enum.SECONDARY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImuMuxSourcePb_Enum.UNRECOGNIZED;
  }
}

export function imuMuxSourcePb_EnumToJSON(object: ImuMuxSourcePb_Enum): string {
  switch (object) {
    case ImuMuxSourcePb_Enum.INVALID:
      return "INVALID";
    case ImuMuxSourcePb_Enum.PRIMARY:
      return "PRIMARY";
    case ImuMuxSourcePb_Enum.SECONDARY:
      return "SECONDARY";
    case ImuMuxSourcePb_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseImuMuxSourcePb(): ImuMuxSourcePb {
  return {};
}

export const ImuMuxSourcePb = {
  encode(_: ImuMuxSourcePb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ImuMuxSourcePb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImuMuxSourcePb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ImuMuxSourcePb {
    return {};
  },

  toJSON(_: ImuMuxSourcePb): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ImuMuxSourcePb>, I>>(base?: I): ImuMuxSourcePb {
    return ImuMuxSourcePb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImuMuxSourcePb>, I>>(_: I): ImuMuxSourcePb {
    const message = createBaseImuMuxSourcePb();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
